// Dev Deepawali campaign — Ganga Aarti at the Varanasi ghats (subject sits on the right).
export const HERO_IMAGE = '/images/backgroundone.png';

/** Festive palette shared by the hero copy, search bar and fireworks. */
export const FESTIVE = {
  gold: '#F5C451',
  goldDeep: '#E09A2B',
  goldBorder: 'rgba(245, 196, 81, 0.38)',
  goldBorderStrong: 'rgba(245, 196, 81, 0.65)',
  navyGlass: 'rgba(8, 15, 40, 0.55)',
  goldGradient: 'linear-gradient(92deg, #FFE7A3 0%, #F5C451 38%, #F0A23B 72%, #FFD27A 100%)',
} as const;

export const HERO_LANGUAGE_OPTIONS = [
  { value: '', label: 'Any language' },
  { value: 'English', label: 'English' },
  { value: 'Hindi', label: 'Hindi' },
  { value: 'French', label: 'French' },
  { value: 'German', label: 'German' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'Japanese', label: 'Japanese' },
  { value: 'Chinese', label: 'Chinese' },
  { value: 'Arabic', label: 'Arabic' },
] as const;

export const HERO_GUIDE_TYPE_OPTIONS = [
  { value: '', label: 'Any type' },
  { value: 'Cultural', label: 'Cultural' },
  { value: 'Adventure', label: 'Adventure' },
  { value: 'Food & Drink', label: 'Food & Drink' },
  { value: 'Photography', label: 'Photography' },
  { value: 'Nature', label: 'Nature' },
  { value: 'History', label: 'History' },
  { value: 'Night Life', label: 'Night Life' },
] as const;

// Live cities are admin-managed: see useLiveCities in features/destinations.
